<div class="flex items-center border border-gray-200 overflow-hidden shrink-0" [ngClass]="{
    'rounded-lg px-1': variant() === 'mobile',
    'rounded-md px-2': variant() === 'desktop'
  }">

  <button  *ngIf="!isCheckout()" (click)="decrease.emit(itemId())" [ngClass]="{
      'flex items-center justify-center text-gray-500': variant() === 'mobile',
      'hover:bg-gray-50 transition': variant() === 'desktop'
    }">
    —
  </button>

  <span [ngClass]="{
      'px-2 text-center text-sm': variant() === 'mobile',
      'py-1 text-base min-w-10 text-center': variant() === 'desktop'
    }">

    {{ qty() | number:'2.0' }}

  </span>

  <button  *ngIf="!isCheckout()" (click)="increase.emit(itemId())" [ngClass]="{
      'flex items-center justify-center text-gray-500': variant() === 'mobile',
      'hover:bg-gray-50 transition': variant() === 'desktop'
    }">
    +
  </button>

</div>
